import { create } from 'zustand'

export interface SidebarStore {
  open: boolean
  setOpen: (open: boolean) => void
  toggleOpen: () => void
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  open: true,
  setOpen: (open) => set({ open }),
  toggleOpen: () => set((s) => ({ open: !s.open })),
}))
